import Vue from 'vue';
import VueI18n from 'vue-i18n';
import { supportedLocalesInclude } from '@/util/i18n/supported-locales';

Vue.use(VueI18n);

const i18n = new VueI18n({
    locale: getActiveLocale(),
    fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || "en",
    messages: loadLocaleMessages()
});

export function loadLocaleMessages() {
    const locales = require.context(
        "./locales",
        true,
        /[A-Za-z0-9-_,\s]+\.json$/i
    );
    const messages = {};
    locales.keys().forEach(key => {
        const matched = key.match(/([A-Za-z0-9-_]+)\./i);
        if (matched && matched.length > 1) {
            const locale = matched[1];
            messages[locale] = locales(key);
        }
    });
    return messages;
}

export function getActiveLocale() {
    var locale = localStorage.getItem('locale');
    if (locale === null || locale === 'null' || locale.trim() === '' || !supportedLocalesInclude(locale)) {
        locale = process.env.VUE_APP_I18N_LOCALE || "en";
    }

    return locale;
}

export default i18n;